<aside class="append-entries-action big-input-grid-with">
  <h4 class="to" >
    <span>with</span>
  </h4>
  <div>
    <app-paired-autocomplete
      #actionDestinationAppendEntries [selectedFieldControl]="sourceFieldControl"
      [secondaryEntityControl]="sourceFieldDescriptorControl"
      [primaryEntity]="primaryEntity"
      [componentId]="'append-entries-destination'"
      [entitiesOptions]="entitiesOptions"
      [inputRequired]="true"
      [dataSourceType]="dataSourceType"
      [placeholder]='placeholder'
      [overlayPositioningConfig]="overlayPositioningConfig"
    >
    </app-paired-autocomplete>
  </div>
</aside>
